/**
 * 获取客户端信息
 * 目前适用于随手记,随管家
 */
import useragent from '@common/useragent'
import { call, uriSuiguanjia, uriSuishouji } from './bridge'

/**
 * callback: 回调函数
 */
export default (callback) => {
  if (useragent.isSuishouji) {
    call(uriSuishouji('requestClientInfo', {}, 'appRequestClientInfoCallback'), 'appRequestClientInfoCallback', (jsonResult) => {
      callback(JSON.parse(jsonResult))
    })
  } else if (useragent.isSuiguanjia) {
    const uri = uriSuiguanjia('sgj://api/getClientInfo', {}, 'appRequestClientInfoCallback')
    call(uri, 'appRequestClientInfoCallback', (jsonResult) => {
      callback(jsonResult)
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestClientInfo.js